import styled from 'styled-components';
import React from 'react';

const BannerWrap = styled.div``;

interface BannerProps {
  img: string;
  onClick?: () => void;
}

const Banner = ({ img, onClick }: BannerProps): JSX.Element => {
  return (
    <BannerWrap>
      <img src={img} onClick={onClick} alt="" />
    </BannerWrap>
  );
};
export default Banner;
